import React from 'react';
import { useGetProductGroup } from 'api/productGroup';
import {
  GetProductGroupParams,
  ProductGroup,
} from 'api/productGroup/productGroup.types';
import { EditableAutocomplete } from './EditableAutocomplete';

interface EditableProductGroupAutocompleteProps {
  value: any;
  onChange: (value: any) => void;
  onSave: (value: any) => void;
  onCancel: () => void;
  disableClearable?: boolean;
}

export const EditableProductGroupAutocomplete: React.FC<
  EditableProductGroupAutocompleteProps
> = ({ disableClearable = false, ...props }) => (
  <EditableAutocomplete<ProductGroup, GetProductGroupParams>
    {...props}
    disableClearable={disableClearable}
    useApiHook={useGetProductGroup}
    getterName='getProductGroup'
    defaultParams={{
      filterText: '',
      resultSize: 25,
      pageNumber: 1,
    }}
    getOptionLabel={(o) => {
      if (typeof o === 'string') return o;
      return o.code || '';
    }}
    isOptionEqualToValue={(option, selectedValue) => {
      if (typeof selectedValue === 'string') {
        return option?.code === selectedValue;
      }
      return selectedValue?.id === option?.id;
    }}
    width={200}
  />
);
